<template>
  <crud-show :open="open"
             :title="title"
             @close="$emit('close')">
    <cash-register-show-data :item="item" />
  </crud-show>
</template>

<script>
import {CrudShow} from '@dracul/common-frontend'
import CashRegisterShowData from "./CashRegisterShowData";

export default {
  name: "CashRegisterShow",
  components: {CrudShow, CashRegisterShowData},
  props:{
    open: {type: Boolean, default: true},
    item: {type: Object, required: true}
  },
  data() {
    return {
      title: 'delivery.cashRegister.showing',
    }
  },
}
</script>
